import * as React from "react";

import CouncilDebt from "./CouncilDebt";
import RevenueBreakdown from "./RevenueBreakdown";
import CouncilRevenue from "./CouncilRevenue";
import StateFederalDebtComparison from "./StateFederalDebtComparison";

const FinanceSection = () => (
  <section className="py-4">
    <div className="container">
      <div className="my-4">
        <h2 className="font-montserrat text-center font-thin text-cct-blue w-full text-3xl">
          What do my council's finances look like?
        </h2>
      </div>
      <div className="my-16">
        <CouncilRevenue />
      </div>
      <div className="my-16">
        <RevenueBreakdown />
      </div>
      <div className="my-16 pb-1">
        <CouncilDebt />
      </div>
      <div className="my-16 pb-1">
        <StateFederalDebtComparison />
      </div>
    </div>
  </section>
);

export default FinanceSection;



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/index.tsx